import { render, staticRenderFns } from "./gdpr-form.vue?vue&type=template&id=58dccba2&"
import script from "./gdpr-form.vue?vue&type=script&lang=ts&"
export * from "./gdpr-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports